import { Fragment } from "react";
import { Link } from "react-router";
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useBreadcrumbs } from "@/hooks/use-breadcrumbs";

// Ported from connect-v2; links go through React Router instead of full page loads.
export function Breadcrumbs() {
	const items = useBreadcrumbs();
	if (items.length === 0) return null;

	return (
		<Breadcrumb>
			<BreadcrumbList>
				{items.map((item, index) => (
					<Fragment key={item.link}>
						{index !== items.length - 1 && (
							<BreadcrumbItem className="hidden md:block">
								<BreadcrumbLink asChild>
									<Link to={item.link}>{item.title}</Link>
								</BreadcrumbLink>
							</BreadcrumbItem>
						)}
						{index < items.length - 1 && <BreadcrumbSeparator className="hidden md:block" />}
						{index === items.length - 1 && <BreadcrumbPage>{item.title}</BreadcrumbPage>}
					</Fragment>
				))}
			</BreadcrumbList>
		</Breadcrumb>
	);
}
